import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  count: 0,
  countPitySSR: 0,
  countPitySR: 0,
  countSSR: 0,
  countSR: 0,
  countR: 0,
  distributionSSR: 0,
  distributionSR: 0,
  distributionR: 0,
  history: [], // entry format: {name: "Awesome Sword Guy", rarity: "SSR", date: new Date()}

  targetPitySSR: 80,
  targetPitySR: 10,
  isPityEnabled: true,
  chanceSSR: 3, 
  chanceSR: 100,
  optionsSSR: ["Awesome Sword Guy", "Beautiful Dancer", "Mysterious Strider", "Excalibur"],
  optionsSR: ["Ring of Power", "Beowulf", "Vladimir", "Morgana", "Siegfried"],
  optionsR: ["Bill", "Mark", "Tom", "Elias", "Claire", "John", "Tim", "Rae", "Lars", "Bjorn"],
}
    // Note for odds: 1000 = 100%, 100 = 10%, 10 = 1% -- for rounding reasons

    // Redux Toolkit allows us to write "mutating" logic in reducers. It
    // doesn't actually mutate the state because it uses the Immer library,
    // which detects changes to a "draft state" and produces a brand new
    // immutable state based off those changes

export const pullsSlice = createSlice({
  name: 'pulls',
  initialState,
  reducers: {
    pullSingle: (state) => {

      if (state.isPityEnabled) {
        state.countPitySSR += 1;
        state.countPitySR += 1;
      }

      var rollRarity = Math.floor(Math.random()*1000) + 1; 

      if (state.countPitySSR >= state.targetPitySSR || 
          rollRarity < state.chanceSSR) {
        // SSR
        state.countSSR += 1;
        
        var rollType = Math.floor(Math.random() * state.optionsSSR.length);
        state.history.unshift({name: state.optionsSSR[rollType], rarity: "SSR", date: new Date().toUTCString()});

        if (state.isPityEnabled) {
          state.countPitySSR = 0;
        }

      } else if(state.countPitySR >= state.targetPitySR ||
                rollRarity < state.chanceSSR + state.chanceSR) {
        // SR
        state.countSR += 1;
        
        rollType = Math.floor(Math.random() * state.optionsSR.length);
        state.history.unshift({name: state.optionsSR[rollType], rarity: "SR", date: new Date().toUTCString()});

        if (state.isPityEnabled) {
          state.countPitySR = 0;
        }

      } else {
        // R
        state.countR += 1;

        rollType = Math.floor(Math.random() * state.optionsR.length);
        state.history.unshift({name: state.optionsR[rollType], rarity: "R", date: new Date().toUTCString()});     
      }

    state.count += 1
    state.distributionSSR = Math.floor(state.countSSR / state.count * 1000) / 10;
    state.distributionSR = Math.floor(state.countSR / state.count * 1000) / 10;
    state.distributionR = Math.floor(state.countR / state.count * 1000) / 10;
    },
    pullMulti: (state) => {
      
      for(var i = 0; i < 10; i++) {

        if (state.isPityEnabled) {
          state.countPitySSR += 1;
          state.countPitySR += 1;
        }

        var rollRarity = Math.floor(Math.random()*1000) + 1;

        if (state.countPitySSR >= state.targetPitySSR || 
            rollRarity < state.chanceSSR) {
        // SSR
          state.countSSR += 1;
          
          var rollType = Math.floor(Math.random() * state.optionsSSR.length);
          state.history.unshift({name: state.optionsSSR[rollType], rarity: "SSR", date: new Date().toUTCString()});

          if (state.isPityEnabled) {
            state.countPitySSR = 0;
          }

        } else if(state.countPitySR >= state.targetPitySR ||
                  rollRarity < state.chanceSSR + state.chanceSR) {
          // SR
          state.countSR += 1;
          
          rollType = Math.floor(Math.random() * state.optionsSR.length);
          state.history.unshift({name: state.optionsSR[rollType], rarity: "SR", date: new Date().toUTCString()});

          if (state.isPityEnabled) {
            state.countPitySR = 0;
          }

        } else {
          // R
          state.countR += 1;

          rollType = Math.floor(Math.random() * state.optionsR.length);
          state.history.unshift({name: state.optionsR[rollType], rarity: "R", date: new Date().toUTCString()});     
        }

        state.count += 1
        state.distributionSSR = Math.floor(state.countSSR / state.count * 1000) / 10;
        state.distributionSR = Math.floor(state.countSR / state.count * 1000) / 10;
        state.distributionR = Math.floor(state.countR / state.count * 1000) / 10;
      }
    },
    editChanceSSR: (state, action) => {
      if (isNaN(action.payload)) { 
        state.chanceSSR = 0; 
        return; 
      }
      if (action.payload * 10 + state.chanceSR >= 1000) {
        state.chanceSSR = 1000 - state.chanceSR;
      } else {
        state.chanceSSR = parseFloat(action.payload) * 10;
      }
      
    },
    editChanceSR: (state, action) => {
      if (isNaN(action.payload)) { 
        state.chanceSR = 0; 
        return; 
      }
      if (action.payload * 10 + state.chanceSSR >= 1000) {
        state.chanceSR = 1000 - state.chanceSSR;
      } else {
      state.chanceSR = parseFloat(action.payload) * 10;
      }
    },
    toggleIsPityEnabled: (state) => {
      state.isPityEnabled = !state.isPityEnabled;
    },
    reset: (state) => {
      state.count = 0;
      state.countPitySSR = 0;
      state.countPitySR = 0;
      state.countSSR = 0;
      state.countSR = 0;
      state.countR = 0;
      state.distributionSSR = 0;
      state.distributionSR = 0;
      state.distributionR = 0;
      state.history = [];
      
      state.targetPitySSR = 80;
      state.targetPitySR = 10;
      state.chanceSSR = 3;
      state.chanceSR = 100;
    }
  },
})

// Action creators are generated for each case reducer function
export const { pullSingle, pullMulti, editChanceSSR, editChanceSR, toggleIsPityEnabled, reset } = pullsSlice.actions

export default pullsSlice.reducer